document.addEventListener('DOMContentLoaded', function() {
  const tabsWrapper = document.querySelector('.PdpHero-tabs-wrapper');
  if (!tabsWrapper) return;

  // Check if tabs can be closed (setting from block)
  const allowCloseTabs = tabsWrapper.dataset.allowCloseTabs === 'true';

  // Desktop tab functionality only
  const tabButtons = tabsWrapper.querySelectorAll('.PdpHero-tab-btn');
  const tabPanels = tabsWrapper.querySelectorAll('.PdpHero-tab-panel');
  const accordionItems = tabsWrapper.querySelectorAll('.PdpHero-content_accordion');
  const accordionTitles = tabsWrapper.querySelectorAll('.PdpHero-content_accordion_title');

  // Initialize: if allowCloseTabs is false, activate first tab
  if (!allowCloseTabs && tabButtons.length > 0) {
    tabButtons[0].classList.add('active');
    if (tabPanels.length > 0) {
      tabPanels[0].classList.add('active');
    }
  }

  // Function to sync active states between desktop and mobile
  function syncMobileFromDesktop(activeTabId) {
    // Remove active class from all accordion items
    accordionItems.forEach(item => {
      item.classList.remove('PdpHero-content_accordion--active');
    });
    
    // Add active class to corresponding accordion item (only if activeTabId is provided)
    if (activeTabId) {
      let targetAccordion = null;
      if (activeTabId === 'included') {
        targetAccordion = tabsWrapper.querySelector('.pdp_included');
      } else if (activeTabId === 'dimensions') {
        targetAccordion = tabsWrapper.querySelector('.pdp_dimensions');
      } else if (activeTabId === 'assembly') {
        targetAccordion = tabsWrapper.querySelector('.pdp_assembly');
      }
      
      if (targetAccordion) {
        targetAccordion.classList.add('PdpHero-content_accordion--active');
      }
    }
  }

  function syncDesktopFromMobile(accordionClass) {
    // Remove active class from all tabs and panels
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabPanels.forEach(panel => panel.classList.remove('active'));
    
    // Add active class to corresponding tab and panel
    let targetTabId = null;
    if (accordionClass.includes('pdp_included')) {
      targetTabId = 'included';
    } else if (accordionClass.includes('pdp_dimensions')) {
      targetTabId = 'dimensions';
    } else if (accordionClass.includes('pdp_assembly')) {
      targetTabId = 'assembly';
    }
    
    if (targetTabId) {
      const targetButton = tabsWrapper.querySelector(`[data-tab="${targetTabId}"]`);
      const targetPanel = tabsWrapper.querySelector(`#${targetTabId}`);
      if (targetButton) targetButton.classList.add('active');
      if (targetPanel) targetPanel.classList.add('active');
    }
  }

  // Desktop tab click functionality
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const targetTab = button.getAttribute('data-tab');
      const isCurrentlyActive = button.classList.contains('active');
      
      // If allowCloseTabs is enabled and tab is already active, close it
      if (allowCloseTabs && isCurrentlyActive) {
        button.classList.remove('active');
        const targetPanel = tabsWrapper.querySelector('#' + targetTab);
        if (targetPanel) {
          targetPanel.classList.remove('active');
        }
        // Sync with mobile accordion (close all)
        syncMobileFromDesktop(null);
        return;
      }
      
      // Remove active class from all buttons and panels
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));
      
      // Add active class to clicked button and corresponding panel
      button.classList.add('active');
      const targetPanel = tabsWrapper.querySelector('#' + targetTab);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
      
      // Sync with mobile accordion
      syncMobileFromDesktop(targetTab);
    });
  });

  // Mobile accordion click functionality - use capture to run before existing JS
  accordionTitles.forEach(title => {
    title.addEventListener('click', (e) => {
      // Prevent default behavior and stop ALL event bubbling/capturing
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const accordionItem = title.closest('.PdpHero-content_accordion');
      const accordionClass = accordionItem.className;
      const isCurrentlyActive = accordionItem.classList.contains('PdpHero-content_accordion--active');
      
      // If the clicked item wasn't active, open it
      if (!isCurrentlyActive) {
        accordionItem.classList.add('PdpHero-content_accordion--active');
        // Sync with desktop tabs
        syncDesktopFromMobile(accordionClass);
      } else {
        accordionItem.classList.remove('PdpHero-content_accordion--active');

        // If we're closing the accordion and allowCloseTabs is false, sync desktop to show first tab
        if (!allowCloseTabs) {
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabPanels.forEach(panel => panel.classList.remove('active'));
          const firstTab = tabButtons[0];
          const firstPanel = tabPanels[0];
          if (firstTab && firstPanel) {
            firstTab.classList.add('active');
            firstPanel.classList.add('active');
          }
        } else {
          // If allowCloseTabs is true, close all desktop tabs too
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabPanels.forEach(panel => panel.classList.remove('active'));
        }
      }
      
      return false; // Extra prevention
    }, true); // Use capture phase to run before existing JS
  });

  // Preserve existing "Read more" functionality for both desktop and mobile
  const readMoreLinks = tabsWrapper.querySelectorAll('.read-more');
  readMoreLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const parent = this.closest('.PdpHero-content_accordion-text-description');
      const preview = parent.querySelector('.preview');
      const moreText = parent.querySelector('.more-text');
      
      if (preview && moreText) {
        preview.style.display = 'none';
        moreText.style.display = 'inline';
        this.style.display = 'none';
      }
    });
  });
});